<template>
<w-main-template class="dashboard-main">
  <div :class="$style['side-h']" slot="sideContent">
    <w-side-setting-switch
      style="position: absolute; top: 0; right: 0; padding-right: 20px; padding-top: 35px;"
      v-if="isCoordDashboard && isEditMode">
    </w-side-setting-switch>
    <keep-alive>
      <component :is="sideComponent" />
    </keep-alive>
  </div>
  <w-dashboard-toolbar slot="mainTitle"></w-dashboard-toolbar>
  <div slot="mainContent" class="full-wrapper" v-loading="isDashboardLoading" >
    <!-- 그리드 레이아웃 영역 -->
    <component :is="layoutComponent" :class="[isCoordDashboard ? $style['coord-dashboard-wrapper'] : '']"/>
    <!-- <w-dashboard-layout></w-dashboard-layout> -->

    <!-- 트리 편집 모드에 따른 컨텐츠 영역 비활성화 -->
    <div :class="[isTreeEditMode ? $style['disabled-mask'] : '']"></div>

    <!-- 슬라이드 팝업 -->
    <w-dashboard-group-setting-popup ref="dashboardGroupSettingPopup" />
    <w-dashboard-setting-popup ref="dashboardSettingPopup" />
    <w-dashboard-setting-on-edit-popup ref="dashboardSettingOnEditPopup" />
    <w-widget-setting-popup ref="widgetSettingPopup" />
    <w-sql-setting-popup ref="sqlSettingPopup" />
    <w-dashboard-slideshow-setting-popup ref="dashboardSlideshowSettingPopup" />
    <w-slideshow-edit-popup ref="slideshowEditPopup" />
    <w-event-list-popup ref="eventListPopup" />
    <w-object-select-popup ref="objectSelectPopup" />
    <w-log-select-popup ref="LogSelectPopup" />
    <w-image-select-popup ref="imageSelectPopup" />
    <w-image-setting-popup ref="imageSettingPopup" />

    <!-- 위젯 최대화 -->
    <w-widget-expand-popup></w-widget-expand-popup>

    <!-- 대시보드 전체화면 -->
    <w-grid-dashboard-fullscreen-popup></w-grid-dashboard-fullscreen-popup>
    <w-coord-dashboard-fullscreen-popup></w-coord-dashboard-fullscreen-popup>
  </div>
</w-main-template>
</template>

<script>
import Vue from 'vue';

import DashboardConst from '@/constants/dashboard';

import WMainTemplate from '@/components/template/MainTemplate';

import Base from '@/mixins/dashboard/base';

import WDashboardWidgetList from '@/views/dashboard/components/frame/DashboardWidgetList';
import WDashboardElementList from '@/views/dashboard/components/frame/DashboardElementList';
import WDashboardList from '@/views/dashboard/components/frame/DashboardList';
import WGridDashboardLayout from '@/views/dashboard/components/frame/GridDashboardLayout';
import WCoordDashboardLayout from '@/views/dashboard/components/frame/CoordDashboardLayout';
import WDashboardToolbar from '@/views/dashboard/components/frame/DashboardToolbar';
import WDashboardGroupSettingPopup from '@/views/dashboard/components/popup/DashboardGroupSettingPopup';
import WDashboardSettingPopup from '@/views/dashboard/components/popup/DashboardSettingPopup';
import WWidgetSettingPopup from '@/views/dashboard/components/popup/WidgetSettingPopup';
import WSqlSettingPopup from '@/views/dashboard/components/popup/SqlSettingPopup';
import WDashboardSlideshowSettingPopup from '@/views/dashboard/components/popup/DashboardSlideshowSettingPopup';
import WWidgetExpandPopup from '@/views/dashboard/components/popup/WidgetExpandPopup';
import WGridDashboardFullscreenPopup from '@/views/dashboard/components/popup/GridDashboardFullscreenPopup';
import WCoordDashboardFullscreenPopup from '@/views/dashboard/components/popup/CoordDashboardFullscreenPopup';
import WDashboardWidgetSettingSide from '@/views/dashboard/components/frame/DashboardWidgetSettingSide';
import WEventListPopup from '@/views/dashboard/components/popup/EventListPopup';
import WObjectSelectPopup from '@/views/dashboard/components/popup/ObjectSelectPopup';
import WLogSelectPopup from '@/views/dashboard/components/popup/LogSelectPopup';
import WImageSelectPopup from '@/views/dashboard/components/popup/ImageSelectPopup';
import WImageSettingPopup from '@/views/dashboard/components/popup/ImageSettingPopup';
import WDashboardSettingOnEditPopup from '@/views/dashboard/components/popup/DashboardSettingOnEditPopup';
import WSlideshowEditPopup from '@/views/dashboard/components/popup/SlideshowEditPopup';
import WSideSettingSwitch from '@/views/dashboard/components/SideSettingSwitch';

Vue.prototype.$dashboardEventBus = new Vue(); // 대시보드에서 사용할 이벤트버스 등록


export default {
  name: 'WDashboard',
  components: {
    WMainTemplate,
    WGridDashboardLayout,
    WCoordDashboardLayout,
    WDashboardWidgetList,
    WDashboardElementList,
    WDashboardList,
    WDashboardToolbar,
    WDashboardGroupSettingPopup,
    WDashboardSettingPopup,
    WWidgetSettingPopup,
    WSqlSettingPopup,
    WDashboardSlideshowSettingPopup,
    WWidgetExpandPopup,
    WGridDashboardFullscreenPopup,
    WCoordDashboardFullscreenPopup,
    WDashboardWidgetSettingSide,
    WEventListPopup,
    WObjectSelectPopup,
    WImageSelectPopup,
    WImageSettingPopup,
    WDashboardSettingOnEditPopup,
    WSlideshowEditPopup,
    WLogSelectPopup,
    WSideSettingSwitch,
  },
  mixins: [Base],
  data() {
    return {
      DashboardConst,
    };
  },
  computed: {
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
    /**
     * 좌측 영역에 그려질 컴포넌트 반환
     * @author KangBonghun(toto1323)
     * @return {Component} [description]
     */
    sideComponent() {
      if (!this.isEditMode) {
        return WDashboardList;
      }

      if (this.sideSettingType === DashboardConst.SIDE_SETTING_TYPE.SETTING) {
        return WDashboardWidgetSettingSide;
      }

      if (this.isCoordDashboard) {
        return WDashboardElementList;
      }

      return WDashboardWidgetList;
    },
    /**
     * 대시보드 구분에 따른 레이아웃 컴포넌트 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    layoutComponent() {
      if (this.selectedNode.dashboardType) {
        if (this.selectedNode.dashboardType === DashboardConst.DASHBOARD_TYPE.GRID) {
          return WGridDashboardLayout;
        } else if (this.selectedNode.dashboardType === DashboardConst.DASHBOARD_TYPE.COORD && !this.isFullScreen) {
          return WCoordDashboardLayout;
        }
      }
      return null;
    },
  },
  mounted() {
  },
};
</script>

<style module>
.side-h {
  height: calc(100% - 82px - 40px) /* 100% - title - header */
}

.disabled-mask {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background: #333;
  opacity: 0.7;
  z-index: 1000;
}

.coord-dashboard-wrapper {
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  display: block;
  /* position: relative; */
  /* padding-right: 20px; */
  /* padding-bottom: 20px; */
  margin-top: -20px;
  margin-left: -20px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue